import { FC, useRef, useEffect, useState, useMemo } from 'react'
import { HStack, Box, Text } from '@chakra-ui/react'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import { cleanupString } from 'shared/utils/tests'
import { ReactComponent as IconList } from 'shared/assets/bsList.svg'

type Props = {
  t: IMatch
  isComplete?: boolean
  isExamination?: boolean
}

export type IMatch = {
  id?: string
  value: string
  displayValue?: string
  correct?: boolean
  droppedValue?: string
  droppedDisplayValue?: string
}

const DraggableWord: FC<Props> = ({ t, isComplete, isExamination }) => {
  const [dragging, setDragging] = useState<boolean>(false)
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current

    return draggable({
      element: el,
      onDragStart: () => setDragging(true),
      onDrop: () => setDragging(false),
      canDrag(args) {
        return isExamination ? !isComplete : !has(t, 'correct')
      },
      getInitialData: () => ({
        value: cleanupString(t.value, false),
        displayValue: t.displayValue,
        matchId: t.id
      })
    })
  }, [t.value, t.id, isComplete, t.correct, isExamination])

  const { bg, color, borderColor } = useMemo(() => {
    if (!isExamination) {
      if (has(t, 'correct') && t.correct) {
        return {
          bg: 'green.50',
          borderColor: 'green.800',
          color: 'green.800'
        }
      } else if (has(t, 'correct') && !t.correct) {
        return {
          bg: 'red.50',
          borderColor: 'red.700',
          color: 'red.700'
        }
      } else if (dragging) {
        return {
          bg: 'wood.100',
          borderColor: 'wood.100',
          color: 'white'
        }
      } else {
        return {
          bg: 'wood.300',
          borderColor: 'wood.300',
          color: 'white'
        }
      }
    } else {
      if (has(t, 'correct') && t.correct && isComplete) {
        return {
          bg: 'green.50',
          borderColor: 'green.800',
          color: 'green.800'
        }
      } else if (has(t, 'correct') && !t.correct && isComplete) {
        return {
          bg: 'red.50',
          borderColor: 'red.700',
          color: 'red.700'
        }
      } else if (dragging) {
        return {
          bg: 'wood.100',
          borderColor: 'wood.100',
          color: 'white'
        }
      } else {
        return {
          bg: 'wood.300',
          borderColor: 'wood.300',
          color: 'white'
        }
      }
    }
  }, [t, dragging, isComplete, isExamination])

  return (
    <HStack w='auto' justify='flex-start' spacing={1} cursor={'pointer'}>
      <HStack
        ref={ref}
        // minW={isComplete ? 16 : 0}
        // w='fit-content'
        px={2}
        h={8}
        // bg={isDraggedOver ? 'red.200' : 'transparent'}
        rounded={'4px'}
        borderWidth={1}
        borderColor={borderColor}
        color={color}
        bg={bg}
        // position={'absolute'}
      >
        <Box>
          <Text textStyle={'body'}>{(t.displayValue || t.value).toLowerCase()}</Text>
        </Box>
        <IconList width='14' height='14' />
      </HStack>
    </HStack>
  )
}

export default DraggableWord
